import { render } from "./TouchHeader.vue?vue&type=template&id=733de4b9&scoped=true&ts=true"
import script from "./TouchHeader.vue?vue&type=script&lang=ts"
export * from "./TouchHeader.vue?vue&type=script&lang=ts"

import "./TouchHeader.vue?vue&type=style&index=0&id=733de4b9&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-733de4b9"]])

export default __exports__